/*----------------------------------*\
||  0.0 Total Index                 ||
||==================================||
|| Main.js
|| - Dragula,
||   Default/general functions
||   Events
||
|| Publication.js
|| - Loading an specific publication
||   overlay file
||
|| Filter.js
|| - filtering the publications
||
|| Favorites.js
|| - publications (inside list)
||
|| Favorite.js
|| - All functions and events for
||   Adding favorites to users
||
|| Binder.js
|| - Creating, renaming and deleting
||   Binders created on front-end
||
|| Dropover.js
|| - The fully customizable pop-up
||   tooltip. Used for favorites over-
||   lay and the settings tooltip
||
|| Posts_per_page.js
|| - Set the users posts per page
||   count
||
|| Repeater.js
|| - stuff for front-end repeater,
||   Probably not used.
||
|| Social.js
|| - Social sharing links
||
\*----------------------------------*/

/*jslint unparam: true, browser: true, indent: 2 */
(function($, window, document, undefined) {
  "use strict";

  // cache global & much used references
  var $doc = $(document),
    $window = $(window),
    $body = document.getElementsByTagName("body")[0];

  window.onload = function() {
    if (
      Foundation.MediaQuery.atLeast("medium") &&
      document.body.classList.contains("home")
    ) {
      Particles.init({
        sizeVariations: 7,
        maxParticles: 40,
        selector: ".particles-background",
        connectParticles: true,
        minDistance: 450,
        color: "#abb3af",
      });
    }
  };

  $doc.ready(function(jQuery) {
    /*-----------------------------------*\
    ||  Language switcher                ||
    \*-----------------------------------*/

    $(".language-radio").on("click", function(e) {
      var _ = $(this),
        url = _.data("url");
      _.toggleClass("checked");
      setTimeout(function() {
        window.location = url;
      }, 250);
    });

    /*-----------------------------------*\
    ||  Search history                   ||
    \*-----------------------------------*/

    function GetIEVersion() {
      var sAgent = window.navigator.userAgent;
      var Idx = sAgent.indexOf("MSIE");

      // If IE, return version number.
      if (Idx > 0)
        return parseInt(sAgent.substring(Idx + 5, sAgent.indexOf(".", Idx)));
      // If IE 11 then look for Updated user agent string.
      else if (!!navigator.userAgent.match(/Trident\/7\./)) return 11;
      else return 0; //It is not IE
    }

    document.getElementById("search").addEventListener("input", function(e) {
      // if user started typing show history
      if (e.target.value.length > 0) {
        displaySearchHistory(e.target.value);
        $(".input-dimmer").fadeIn();
      } else if (e.target.value.length === 0) {
        $(".history-wrapper").slideUp();
        $(".input-dimmer").fadeOut();
      }
    });

    // Add to search history
    const addToSearchHistory = searchParam => {
      // const MAXLENGTH = 3;
      const history = JSON.parse(
        localStorage.getItem("kwrSearchHistory") || "[]"
      );
      // const workingHistory = history.length === MAXLENGTH ? history.slice(1) : history;
      // if history contains same search params return else add to history
      if (GetIEVersion() == 0) {
        if (history.includes(searchParam)) {
          return;
        }
      }
      const updatedHistory = [searchParam].concat(history);
      localStorage.setItem("kwrSearchHistory", JSON.stringify(updatedHistory));
    };

    // Show search history

    const displaySearchHistory = value => {
      const history = JSON.parse(
        localStorage.getItem("kwrSearchHistory") || "[]"
      );
      // Filter history by input value
      // console.log(history);
      let filteredHistory = history.filter(item =>
        item.toLowerCase().includes(value.toLowerCase())
      );
      const historyResults =
        filteredHistory.length > 0 ? filteredHistory : history;
      let historyContainer = document.getElementById("historyplaceholder");
      // show only 3 items
      if (historyResults.length > 0) {
        let historyHTML = historyResults
          .slice(0, 3)
          .map(
            h => `
          <div class="history-item-wrapper" data-search="${h}">
            <span class="history-item">${h}</span>
            <span class="icon-arrow-right"></span>
          </div>
        `
          )
          .join("");
        historyContainer.innerHTML = historyHTML;
        $(".history-wrapper").slideDown();
      }
    };

    $doc.on("click", ".history-item-wrapper", e => {
      const searchValue = e.currentTarget
        .querySelector(".history-item")
        .textContent.replace(/\+/g, "%2B");

      //const search = location.search.replace(/search=[^\&]+/, 'search='+searchValue);
      changeLocationSearch(searchValue);
    });

    // Clear Search History
    const clearSearchHistory = () => {
      localStorage.removeItem("kwrSearchHistory");
    };

    $(".js-clear-history").on("click", function(e) {
      clearSearchHistory();
      $(".history-wrapper").slideUp();
    });

    //Hike input dimmer
    $(document).on("click", ".input-dimmer", function() {
      $(".input-dimmer").fadeOut();
      $(".history-wrapper").slideUp();
    });

    /*-----------------------------------*\
    ||  Tips slider                      ||
    \*-----------------------------------*/

    $(".tips-slider").slick({
      arrows: false,
      dots: true,
      autoplay: true,
      autoplaySpeed: 5000,
    });

    localStorage.setItem("reference_url", document.location.href);

    var drake;

    /**
     * Function to start running dragula
     * and to enable drag 'n drop
     **/
    function initDragula(drake) {
      drake = dragula({
        isContainer: function(el) {
          return el.classList.contains("dragula-container"); // Every Element with this class is a dragula container
        },
        moves: function(el, source, handle, sibling) {
          return true;
        },
        accepts: function(el, target, source, sibling) {
          return true; // elements can be dropped in any of the `containers` by default
        },
        invalid: function(el, handle) {
          // return false; // don't prevent any drags from initiating by default
          return el.classList.contains("no-drag");
        },
        direction: "vertical", // Y axis is considered when determining where an element would be dropped
        copy: false, // elements are moved by default, not copied
        copySortSource: true, // elements in copy-source containers can be reordered
        revertOnSpill: true, // spilling will put the element back where it was dragged from, if this is true
        removeOnSpill: false, // spilling will `.remove` the element, if this is true
        mirrorContainer: document.body, // set the element that gets mirror elements appended
        ignoreInputTextSelection: true, // allows users to select input text, see details below
      })
        // When dragging
        .on("drag", function(el) {
          el.className = el.className.replace(" ex-moved", "");
        })

        // Drop element in container
        .on("drop", function(el, container) {
          el.className += " ex-moved";
          if (
            container.classList.contains("binder") &&
            el.getAttribute("data-binder") !=
              container.getAttribute("data-binder")
          ) {
            // Only do this code if the publication is placed into a binder that isn't the active one
            var id = el.getAttribute("data-post"), // get the publication id
              target = container.getAttribute("data-binder"), // get the target binder id
              origin = el.getAttribute("data-binder"), // get the origin binder id
              origin_el = document.getElementById(origin); // the actual element that is connected to the origin binder id

            $.when(addToBinder(id, target, origin)).done(
              function() {
                /*console.group('Adding to binders');
                console.log('Origin contains', origin_el.dataset.contains);
                console.log('Origin type', typeof origin_el.dataset.contains);
                console.log('Destination contains', container.dataset.contains);
                console.log('Destination type', typeof container.dataset.contains);
              console.groupEnd();
              */

                if (origin_el.getAttribute("data-contains") == "1") {
                  // Decrement the post count of the Origin by one
                  // delete origin_el.dataset.contains;
                  origin_el.removeAttribute("data-contains");
                } else {
                  origin_el.setAttribute(
                    "data-contains",
                    parseInt(origin_el.getAttribute("data-contains")) - 1
                  );
                  // console.log(parseInt(origin_el.dataset.contains) );
                }

                if (container.getAttribute("data-contains")) {
                  // Increment the post count of the Target by one
                  container.setAttribute(
                    "data-contains",
                    parseInt(container.getAttribute("data-contains")) + 1
                  );
                } else {
                  // Or set it to one if it does not exist yet
                  container.setAttribute("data-contains", "1");
                }
                $(el).remove(); // only remove the publication if the ajax call is succesful.
              }

              /*console.group('Result of adding');
                console.log('Origin contains', origin_el.dataset.contains);
                console.log('Origin type', typeof origin_el.dataset.contains);
                console.log('Destination contains', container.dataset.contains);
                console.log('Destination type', typeof container.dataset.contains);
              console.groupEnd();
              */
            );
          } else if (
            el.getAttribute("data-binder") ==
            container.getAttribute("data-binder")
          ) {
            // console.log('target is same as origin');
          }
        })

        // Mouse Over
        .on("over", function(el, container) {
          // console.log(container);
          container.className += " hover";
        })

        // Mouse Out
        .on("out", function(el, container) {
          container.className = container.className.replace(" hover", "");
        });

      return drake;
    }

    /**
     * Function to destroy Dragula
     * Get the torches and pithforks! ---E
     * Put a stake through it's heart!
     **/
    function dragulaDestroy(drake) {
      dragula().destroy();

      return drake;
    }

    /*-----------------------------------*\
    ||  2.0 Editing Favorites page       ||
    \*-----------------------------------*/

    /**
     *
     *   Button to edit favorites
     *       When clicked on button:
     *       - the class 'edit-favorites' is added to the body
     *       - on this class changes other stuff becomes visible and other stuff hides
     *
     **/
    if (
      $body.classList.contains("favorites-page") &&
      $body.classList.contains("logged-in")
    ) {
      var $button = document.getElementById("edit-favorites");

      $button.addEventListener("click", function(e) {
        var buttonText;
        if (!$button.classList.contains("done-editing")) {
          e.preventDefault();
          document.getElementsByTagName("body")[0].className +=
            " edit-favorites";
          $button.className += " red done-editing";

          // Set button text to (translation of) 'Done editing'
          buttonText = $button.getAttribute("data-done");
          $button.innerHTML = buttonText;

          $(".dragula-element:not(.current-binder)")
            .removeClass("dragula-element")
            .addClass("dragula-container");
          $("#default")
            .removeClass("dragula-container")
            .removeClass("dragula-element");

          // Init Dragula
          initDragula(drake);

          $(".add-binder-wrapper").slideDown(300);
        } else {
          e.preventDefault();
          document
            .getElementsByTagName("body")[0]
            .classList.remove("edit-favorites");
          $button.className = "button full-width button-not-clickable";

          $(".add-binder").removeClass("active");

          $(".container-list")
            .children(".edit-binder-form")
            .remove();
          $(".container-list")
            .addClass("binder dragula-container")
            .removeClass("rename-binder active");

          document.getElementById("create-binder-input").value = "";

          buttonText = $button.getAttribute("data-start");
          $button.innerHTML = buttonText;

          $(".dragula-container")
            .removeClass("dragula-container")
            .addClass("dragula-element");
          $("#default")
            .removeClass("dragula-container")
            .removeClass("dragula-element");

          // destroy Dragula
          dragulaDestroy(drake);

          $(".add-binder-wrapper").slideUp(300);

          var elements = document.getElementsByClassName("publication");
          for (var i = 0, l = elements.length; i < l; i++) {
            elements[i].classList.remove("marked-for-delete");
            elements[i].classList.remove("no-drag");
          }
        }
      });
    }

    /*----------------------------------*\
    ||  3.0 Deleting publications       ||
    \*----------------------------------*/

    /**
     *
     *   Mark publication for delete / DELETE PUBLICATION
     *   When the user wants to delete a publication
     *     (the part with the y/n confirmation pushing aside the publication itself)
     *
     **/
    $(document).click(function() {
      $(".marked-for-delete")
        .removeClass("marked-for-delete")
        .removeClass("no-drag");
    });

    $(".publication .block-wrapper .mark-for-delete").on("click", function(e) {
      e.preventDefault();
      e.stopPropagation();
      $(this)
        .closest(".publication")
        .addClass("marked-for-delete")
        .addClass("no-drag");
    });

    $(".delete-favourite").on("click", function(e) {
      e.preventDefault();
      e.stopPropagation();

      var id = $(this)
          .closest(".publication")
          .attr("data-post"),
        binder = $(".binder.current-binder").attr("id");

      $.when(removeFromBinder(id, binder)).done(function() {
        $('.publication[data-post="' + id + '"]').remove();
      });
    });

    $(".publication .block-wrapper .button").on("click", function(e) {
      e.preventDefault();
      if (this.id == "no-delete") {
        $(this)
          .closest(".publication")
          .removeClass("marked-for-delete")
          .removeClass("no-drag");
      } else if (this.id == "delete") {
        var id = $(this)
            .closest(".publication")
            .attr("data-post"),
          binder = $(".binder.current-binder").attr("id");

        $.when(removeFromBinder(id, binder)).done(function() {
          $('.publication[data-post="' + id + '"]').remove();
        });
      }
    });

    // Init Login Modal

    if ($("#loginModal").length > 0) {
      let loginModal = new Foundation.Reveal($("#loginModal"));
    }

    /*----------------------------------*\
  ||  1.0 Animations                  ||
  \*----------------------------------*/

    $(".config-settings").on("click", function(e) {
      var self = $(this);

      self.addClass("animating");
      setTimeout(function() {
        self.removeClass("animating");
      }, 500);
    });

    /*----------------------------------*\
    ||  2.0 Set the corrent menu-item   ||
    \*----------------------------------*/
    if (!$body.classList.contains("favorites-page")) {
      var $listItems = document.getElementsByClassName("menu-item"),
        $thisLi = document.getElementsByClassName("publications-item");

      for (var i = 0; i < $listItems.length; i++) {
        $listItems[i].classList.remove("current-menu-item");
      }
      for (i = 0; i < $thisLi.length; i++) {
        $thisLi[i].classList.add("current-menu-item");
      }
    }

    /*----------------------------------*\
    ||  3.0 Home prevent empty search   ||
    \*----------------------------------*/

    $(function() {
      if (!$body.classList.contains("no-js")) {
        $("#searchsubmit").prop("disabled", true);
      }
    });

    if ($("#search").value === "") {
      $("#searchsubmit").attr("disabled", "disabled");
    }

    $("#search").on("change paste keyup", function() {
      if ($(this).val() !== "") {
        setTimeout(function() {
          $("#searchsubmit").prop("disabled", false);
        }, 50);
      } else if ($(this).val() === "") {
        setTimeout(function() {
          $("#searchsubmit").prop("disabled", true);
        }, 50);
      }
    });

    $("#searchsubmit[disabled]").on("click", function(e) {
      e.preventDefault();
      DropOver($(this));
    });

    $("#mainSearch").on("submit", function(e) {
      e.preventDefault();
      var formData = document.getElementById("search").value,
        searchData = encodeURI(formData.trim())
          .replace(/\+/g, "%2B")
          .replace(/\s|%20/g, "+"),
        location = window.location;

      addToSearchHistory(formData.replace(/<(?:.|\n)*?>/gm, ""));

      changeLocationSearch(searchData);
    });

    /*---------------------------------------*\
    ||  4.0 Return to previous page button   ||
    \*---------------------------------------*/

    $(".return-page").on("click", function(e) {
      e.preventDefault();
      window.history.back();
    });

    /*---------------------------------------*\
    ||  5.0 Fix Polylang on overview page    ||
    \*---------------------------------------*/

    var currentPage = window.location.href;
    setInterval(function() {
      //if (currentPage != window.location.href){
      currentPage = window.location.href;
      if (window.location.href.indexOf("/publicaties/filter/") > -1) {
        var data_url = currentPage.replace(
          "/publicaties/filter/",
          "/en/publications/filter/"
        );
        $(".switcher").attr("data-url", data_url);
      }
      if (window.location.href.indexOf("/en/publications/filter/") > -1) {
        var data_url = currentPage.replace(
          "/en/publications/filter/",
          "/publicaties/filter/"
        );
        $(".switcher").attr("data-url", data_url);
      }
      //}
    }, 500);
  });
})(jQuery, window, document);

/*---------------------------------------*\
||  5.0 Miscellaneous functions           ||
\*---------------------------------------*/
/**
 * Add publication to binder
 * @param id     int    - ID of publication
 * @param target string - ID of target binder
 * @param target string - ID of origin binder
 **/
function addToBinder(id, target, origin) {
  var add;
  if (target == "default" && typeof origin == "undefined") {
    add = $.ajax({
      type: "POST",
      url: KWR.ajaxurl,
      dataType: "json",
      data: {
        action: "savePost",
        publication_id: id,
      },
    });
  } else {
    add = $.ajax({
      type: "POST",
      url: KWR.ajaxurl,
      dataType: "json",
      data: {
        action: "updateBinder",
        publication_id: id,
        binder_id: target,
        origin_id: origin,
      },
    });
  }

  return add;
}

/**
 * Remove publication from binder
 * @param id     int    - ID of publication
 * @param binder string - ID of binder
 **/
function removeFromBinder(id, binder) {
  var remove;
  if (binder == "default") {
    remove = $.ajax({
      type: "POST",
      url: KWR.ajaxurl,
      dataType: "json",
      data: {
        action: "removePost",
        publication_id: id,
        binder_id: binder,
      },
    });
  } else {
    remove = $.ajax({
      type: "POST",
      url: KWR.ajaxurl,
      dataType: "json",
      data: {
        action: "removePub",
        publication_id: id,
        binder_id: binder,
      },
    });
  }

  return remove;
}

/**
 * Set a cookie
 * @param name  string - name of the cookie
 * @param value string - value the cookie contains, mostly (and most useful) a JSON String of an array
 * @param days  int    - Number of days the cookies should remain
 **/
function createCookie(name, value, days) {
  var expires = "";
  if (days) {
    var date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    expires = "; expires=" + date.toGMTString();
  }
  document.cookie = name + "=" + value + expires + "; path=/";
}

/**
 * Read a cookie with this function
 * @param name  string - name of the cookie
 **/
function readCookie(name) {
  var nameEQ = name + "=";
  var ca = document.cookie.split(";");
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) == " ") c = c.substring(1, c.length);
    if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
  }
  return null;
}

/**
 * Delete cookie with this function
 * @param name  string - name of the cookie
 **/
function eraseCookie(name) {
  createCookie(name, "", -1);
}

/**
 * Create random string for use as ID, Nonce, etc.
 * @param length int    - length of the string in numbers
 * @param chars  string - string of available characters to use for creating the string
 **/
function randomString(length, chars) {
  var result = "";
  for (var i = length; i > 0; --i)
    result += chars[Math.round(Math.random() * (chars.length - 1))];
  return result;
}

/**
 * Escape strings for use in RegEx
 * @param str string - string that needs to be escaped
 **/
function RegEscape(str) {
  return str.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, "\\$&");
}

function getUrlParam(name) {
  var results = new RegExp("[\\?&]" + name + "=([^&#]*)").exec(
    window.location.href
  );
  return (results && results[1]) || undefined;
}

function changeLocationSearch(searchData = "") {
  const location = window.location;

  let searchQuery = "search=" + searchData;

  if (/search=[^&]+/g.test(location.search)) {
    searchQuery = location.search.replace(/search=[^&]+/g, searchQuery);
  } else {
    searchQuery = location.search + (location.search ? "&" : "?") + searchQuery;
  }

  location.replace(KWR.publicationFilterPage + searchQuery);
}
